// extracted by css-extract-rspack-plugin
export default {"cls1":"Filter-cls1_1rR","cls2":"Filter-cls2_ey6 Filter-cls1_1rR"};